const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/system.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { hasOneOfPermissions } from '@hypeit-gmbh/hypeit-ui-core';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/system')({
  preload: false,
  beforeLoad: ({
    context: {
      permissions
    }
  }) => {
    const hasValidPermission = hasOneOfPermissions(permissions, [{
      permission: 'ADMIN_GROUPS',
      action: 'READ'
    }, {
      permission: 'ADMIN_USERS',
      action: 'READ'
    }]);
    if (!hasValidPermission) {
      throw redirect({
        to: '/',
        replace: true,
        throw: true
      });
    }
  },
  loader: async () => window.location.replace(`${process.env.PUBLIC_DREAMHAUS_URL}/system`),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});